import * as tslib_1 from "tslib";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import OffsetHelper from "@/components/helper/Offset.vue";
let MaterialCardView = class MaterialCardView extends Vue {
    constructor() {
        super();
        this.inheritAttrs = false;
        this.elevation = 10;
    }
    get hasOffset() {
        return this.$slots.header || this.$slots.offset || this.title || this.text;
    }
    get styles() {
        if (!this.hasOffset)
            return null;
        return {
            marginBottom: `${this.offset}px`,
            marginTop: `${this.offset * 2}px`
        };
    }
};
tslib_1.__decorate([
    Prop({ type: String, default: "secondary" })
], MaterialCardView.prototype, "color", void 0);
tslib_1.__decorate([
    Prop({ type: String, default: "secondary" })
], MaterialCardView.prototype, "title", void 0);
tslib_1.__decorate([
    Prop({ type: String, default: "secondary" })
], MaterialCardView.prototype, "text", void 0);
tslib_1.__decorate([
    Prop({ type: Number, default: 10 })
], MaterialCardView.prototype, "elevation", void 0);
tslib_1.__decorate([
    Prop({ type: Number, default: 10 })
], MaterialCardView.prototype, "offset", void 0);
tslib_1.__decorate([
    Prop({ type: Boolean, default: false })
], MaterialCardView.prototype, "inline", void 0);
tslib_1.__decorate([
    Prop({ type: Boolean, default: false })
], MaterialCardView.prototype, "fullWidth", void 0);
MaterialCardView = tslib_1.__decorate([
    Component({
        name: "ProfileComponent",
        components: {
            OffsetHelper
        }
    })
], MaterialCardView);
export default MaterialCardView;
